import { render, staticRenderFns } from "./RegisteredPC.vue?vue&type=template&id=d6f565c0&"
import script from "./RegisteredPC.vue?vue&type=script&lang=js&"
export * from "./RegisteredPC.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredPC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RegisteredPC.vue"
export default component.exports